import type { DisciplineCertificatePayload, DisciplineFilePackDetails } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineCertificateApiOptions {
  disciplineId: string | number
  payload: DisciplineCertificatePayload
  onStart?: () => void
  onFinish?: () => void
}

/** `POST /admin-api/disciplines/{discipline}/certificate` — renders the PDF inside the request (slow). */
export const useDisciplineCertificateApi = async (
  options: DisciplineCertificateApiOptions,
): Promise<DisciplineFilePackDetails | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.certificate', { discipline_id: options.disciplineId })

  options.onStart?.()

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, options.payload)
    toast.success(options.payload.task_id
      ? 'Certificate was successfully generated! Task was successfully completed'
      : 'Certificate was successfully generated!')

    return data.data ?? null
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err) || 'Failed to generate certificate.')
    return null
  } finally {
    options.onFinish?.()
  }
}
